<template>
  <div class="header" v-bind:class="{ fadeOut:  isScroll}">
    <!-- {{scrollY}}{{isScroll}} -->
   <!-- nav-menu -->
    <div class="nav-menu head-element ">
      <div class="nav-menu-wrap" >
        <!-- <router-link to="/">Home</router-link>  -->
        <!-- <router-link to="/project">STAGE</router-link>
        <router-link to="/collection">AWARDS</router-link>
        <router-link to="/about">about</router-link>
        <router-link to="/contact">contact</router-link> -->
      </div> 
    </div> 
    <!-- bland-logo -->
    <div class="bland-logo head-element ">
      <div class="header-logo-wrap" >
          <router-link to="/">
          <img src="../assets/img/h-works1200x600white.svg" class="bland-img-svg" alt="tourdehdr+ logo">
          </router-link>
      </div> 
    </div> 
    <!-- nav-bar -->
    <div class="nav-bar head-element">
      <div class="menu-wrap" v-bind:class="{ menuExpanded: active }">
          <div class="menu" v-on:click="active = !active">
              <div class="bar" v-bind:class="{ bar_expand_color: active, bar_color: !active }"></div>
              <div class="menu-text" v-bind:class="{ menu_text_color_exp: active, menu_text_color: !active }">MENU</div>
          </div>
          <!-- open-full-menu on click open -->
          <nav v-bind:class="{ on_nav: active }">
            <div  id="nav_bg" v-bind:class="{ open_menu: active }"></div>
            <section id="nav_body " >
                <!-- <div class="nav-inner" v-on:click="active = false" v-bind:class="{ d_block: active }"> -->
                <div class="nav-inner" v-on:click="active = false">
                    <div class="nav_item" v-bind:class="{ on_item: active }">
                      <span><router-link to="/" >HOME</router-link></span>
                      <span><router-link to="/project" >STAGE</router-link></span>
                      <span><router-link to="/awards" >AWARDS</router-link></span>
                      <!-- <span><router-link to="/collection" >COLLECTIONS</router-link></span>
                      <span><router-link to="/collection" >TITLES</router-link></span> -->
                      <!-- <span><router-link to="/about" >about</router-link></span>
                      <span><router-link to="/contact" >contact</router-link></span> -->
                    </div>
                </div>
            </section>
          </nav>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  },
  data () {
      return {
          active: null,
          scrollY: 0,
          isScroll: false,

      }
 },
  mounted: function () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll);
  },
 methods: {
   handleScroll() {
      this.scrollY = window.scrollY;
      if(this.scrollY > 250){
        this.isScroll = true;
      }else{
        this.isScroll = false;
      }
   }
 },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

 
</style>
